import { SwModal } from '@kaa/ui-flanders/components';
import React from 'react';
import { useAuthState } from '@kaa/auth/common';
import { Modals } from '../../constants';
import { Routes } from '../../routes';
import {
  ModalType,
  sendCloseModalEvent,
  sendOpenModalEvent,
  sendVirtualPageViewEvent,
} from '../../utils/google-analytics';
import { OnboardingModal } from './OnboardingModal';
import { getOnboarding } from './OnboardingModal.utils';
import { AuthContext } from '../../types';

type OnboardingProps = {
  activeRoute: Routes;
};

export const Onboarding = ({ activeRoute }: OnboardingProps) => {
  const { modalViews, modalContent } = getOnboarding(activeRoute);
  const { selectedCustomerId } = useAuthState<AuthContext>();
  const MAX_VIEWS = 1;

  if (!modalContent) {
    return null;
  }

  if (modalViews < MAX_VIEWS) {
    sendOpenModalEvent(
      `OnboardingModal ${modalContent[0].modalName}`,
      ModalType.TUTORIAL,
      `/onboarding-modal/${modalContent[0].modalName}/step-1`,
    );
  }

  return (
    <SwModal
      open={modalViews < MAX_VIEWS}
      id={Modals.ONBOARDING_MODAL_ID}
      modalId={Modals.ONBOARDING_MODAL_ID}
      slides={modalContent}
      closable
      onClose={() => {
        sendCloseModalEvent(
          `OnboardingModal ${modalContent[0].modalName}`,
          ModalType.TUTORIAL,
          `/onboarding-modal/${modalContent[0].modalName}/step-1`,
        );
        sendVirtualPageViewEvent(
          `/onboarding-modal/${modalContent[0].modalName}/step-1`,
          {
            customerId: selectedCustomerId,
            flowName: `OnboardingModal ${modalContent[0].modalName}`,
          },
        );
      }}
      component={OnboardingModal}
    />
  );
};
